import { Component, Input, inject } from '@angular/core';
import { SiteState } from '@next/core-lib/site';
import { select, Store } from '@ngrx/store';
import { BehaviorSubject } from 'rxjs';
import { switchMap, withLatestFrom } from 'rxjs/operators';
import { CropAid } from 'src/app/crop-aid/crop-aid.model';
import { selectLegalRestriction } from 'src/app/legal-restriction/store/legal-restriction.selectors';

@Component({
  selector: 'app-legal-restriction-info',
  templateUrl: './legal-restriction-info.component.html',
  standalone: false,
})
export class LegalRestrictionInfoComponent {
  private readonly store = inject<Store<SiteState>>(Store);

  cropAid$ = new BehaviorSubject<CropAid>(null);
  cropId$ = new BehaviorSubject<number>(null);
  province$ = new BehaviorSubject<string>(null);

  legalRestriction$ = this.cropAid$.pipe(
    withLatestFrom(this.cropId$),
    switchMap(([cropAid, cropId]) =>
      this.store.pipe(select(selectLegalRestriction(cropAid?.id, cropId))),
    ),
  );

  @Input() set cropAid(cropAid: CropAid) {
    this.cropAid$.next(cropAid);
  }

  @Input() set cropId(cropId: number) {
    this.cropId$.next(cropId);
  }

  @Input() set province(province: string) {
    this.province$.next(province);
  }
}
